import React, { createContext, useContext } from 'react'
import { useAsyncResource } from '../hooks/useAsyncResource'
import { getTeam, parseWordpressRes } from 'services/cms'
import { localTeamData } from 'data/team'

const TeamContext = createContext(null)

export function TeamProvider ({ children }) {
  const teamResource = useAsyncResource(async (signal) => {
    try {
      return await getTeam({ signal })
    } catch {
      // fallback to local data
      return parseWordpressRes(localTeamData)
    }
  })

  const value = {
    team: teamResource.data,
    isTeamLoading: teamResource.loading,
    teamError: teamResource.error,
    fetchTeam: teamResource.load
  }

  return <TeamContext.Provider value={value}>{children}</TeamContext.Provider>
}

export const useTeam = () => {
  const ctx = useContext(TeamContext)
  if (!ctx) throw new Error('useTeam must be used within <TeamProvider>')
  return ctx
}
